class Dropdown {
  constructor(el) {
    this.thisEl = el;
    this.toggleEl = this.thisEl.querySelector('[data-dropdown-toggle]');
    this.toggleTextEl = this.thisEl.querySelector(
      '[data-dropdown-toggle-text]'
    );
    this.toggleDefaultText = this.toggleEl.dataset.default;
    this.btnCloseEl = this.thisEl.querySelector('[data-dropdown-close]');
    this.menu = this.thisEl.querySelector('[data-dropdown-menu]');
    this.menuItems = this.thisEl.querySelectorAll('[data-dropdown-menu-item]');
    this.isActive = false;

    this.start();
  }

  start() {
    // console.log('dropdown work');

    this.toggleEl.addEventListener('click', () => {
      this.toggleDropdown();
    });
    this.btnCloseEl.addEventListener('click', () => {
      this.closeDropdown();
    });
    this.menu.addEventListener('change', (e) => {
      //console.log(e.target.value);
      this.toggleTextEl.innerText = e.target.value;
    });
    this.menuItems.forEach((el) => {
      el.addEventListener('click', () => {
        this.closeDropdown();
      });
    });
  }

  openDropdown() {
    // console.log('Открыть dropdown');

    this.thisEl.classList.add('active');
    this.isActive = true;

    if (!window.matchMedia('(min-width: 576px)').matches) {
      this.doFreeze();
    }
  }

  closeDropdown() {
    // console.log('Закрыть dropdown');

    this.thisEl.classList.remove('active');
    this.isActive = false;

    if (!window.matchMedia('(min-width: 576px)').matches) {
      this.unFreeze();
    }
  }

  toggleDropdown() {
    // console.log('Тоггл dropdown');

    this.thisEl.classList.toggle('active');
    this.isActive = !this.isActive;

    if (!window.matchMedia('(min-width: 576px)').matches) {
      this.doFreeze();
    }
  }

  getScrollbarWidth() {
    const scrollDiv = document.createElement('div');
    scrollDiv.style.cssText =
      'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
    document.body.appendChild(scrollDiv);
    const scrollBarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollBarWidth;
  }

  doFreeze() {
    const html = document.querySelector('html');

    if (html.classList.contains('freeze')) {
      html.classList.remove('freeze');
      // html.style.setProperty('--scrollbar-width', '');
    } else {
      html.classList.add('freeze');
      html.style.setProperty(
        '--scrollbar-width',
        `${this.getScrollbarWidth()}px`
      );
    }
  }

  unFreeze() {
    const html = document.querySelector('html');
    html.classList.remove('freeze');
    // html.style.setProperty('--scrollbar-width', '');
  }
}

export default Dropdown;
